import api from '@/api'

const state = {
  titulosProfesionales: []
}

const getters = {
  titulosProfesionales: (state) => {
    return state.titulosProfesionales
  }
}

const mutations = {
  SET_TITULOS_PROFESIONALES(state, titulosProfesionales) {
    state.titulosProfesionales = titulosProfesionales
  }
}

const actions = {
  async fetchTitulosProfesionales({ commit }) {
    try {
      const response = await api.tituloProfesional.getTitulosProfesionales()
      commit('SET_TITULOS_PROFESIONALES', response.data)
    } catch (err) {
      console.error(err)
      throw err
    }

  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
